import { setupMultistoreRoutes } from '@vue-storefront/core/lib/multistore'
import App from './App.vue'
import routes from './router'
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import '@vue-storefront/core/lib/passive-listeners'
import { RouterManager } from '@vue-storefront/core/lib/router-manager'
import { once } from '@vue-storefront/core/helpers'
import { isServer } from '../../../core/helpers';
import config from 'config';
import 'theme/plugins/leaflet';
import { captureException } from 'theme/plugins/rum';

if (!isServer) {
  Vue.config.errorHandler = (err, vm, info) => {
    console.error('Global error:', err, info);
    if (vm) vm.hasError = err;
    // Vue swallows component errors here (they never reach window.onerror), so
    // forward them to RUM explicitly.
    captureException({
      message: err && err.message ? err.message : String(err),
      stack: err && err.stack ? String(err.stack).slice(0, 2000) : undefined,
      info,
      handler: 'vue',
      page: (window.location && window.location.pathname) || '/'
    });
  };
}
Vue.directive('mask', {
  bind (el, binding) {
    import(/* webpackChunkName: "vsf-inputmask" */ 'inputmask')
      .then(m => { const Inputmask = m.default || m; Inputmask(binding.value).mask(el) })
      .catch(error => console.error('inputmask chunk failed to load; field left unmasked: ', error))
  }
})
if (!isServer && config.cookies) {
  Vue.use(require('vue-cookies'))
  let expires = (config.cookies.expiresInDays ? config.cookies.expiresInDays : 7) + 'd'
  config.cookies.domain ? Vue.$cookies.config(expires, '/', config.cookies.domain) : Vue.$cookies.config(expires);
}
once('__VUE_EXTEND_DROPPOINT_VPB__', () => {
  Vue.use(VueProgressBar)
})

const themeEntry = App
function initTheme (app, router, store, config, ssrContext) {
  // if youre' runing multistore setup this is copying the routed above adding the 'storeCode' prefix to the urls and the names of the routes
  // You can do it on your own and then be able to customize the components used for example for German storeView checkout
  // To do so please execlude the desired storeView from the config.storeViews.mapStoreUrlsFor and map the urls by Your own like:
  // { name: 'de-checkout', path: '/checkout', component: CheckoutCustomized },
  setupMultistoreRoutes(config, router, routes)
  RouterManager.addRoutes(routes, router)
}

export {
  themeEntry,
  initTheme
}
